import switchFunc from 'lib/function/switchFunc'

interface USPDefinition {
  title: string
  subtitle: string
  imageId: string
}

export const UltraluxUSPDefinitions = {
  hotels: {
    premium: switchFunc<USPDefinition>({}, {
      title: 'Exceptional 5 & 6 star properties',
      subtitle: 'Get access to exclusive luxury hotels around the world',
      imageId: 'tujk1y9ccy97sf0dcrk4',
    }),
    service: switchFunc<USPDefinition>({
      IN: {
        title: 'Premium concierge service',
        subtitle: 'Our team are available anytime, 9am to 7pm, 7 days a week.',
        imageId: '86zfuzec9prni5yzhzcd',
      },
    }, {
      title: '24/7 Premium concierge service',
      subtitle: 'Our team are available anytime, 24 hours, 7 days a week',
      imageId: '86zfuzec9prni5yzhzcd',
    }),
  },
  tours: {
    premium: switchFunc<USPDefinition>({}, {
      title: 'Exceptional tours',
      subtitle: 'Get access to expertly curated tours, coupled with the world\'s most prestigious hotels',
      imageId: 'b6xj75dk8i9wji8fit5ch',
    }),
    service: switchFunc<USPDefinition>({
      IN: {
        title: 'Premium concierge service',
        subtitle: 'Our team are available anytime, 9am to 7pm, 7 days a week.',
        imageId: '86zfuzec9prni5yzhzcd',
      },
    }, {
      title: '24/7 Premium concierge service',
      subtitle: 'Our team are available anytime, 24 hours, 7 days a week',
      imageId: '86zfuzec9prni5yzhzcd',
    }),
  },
  cruises: {
    premium: switchFunc<USPDefinition>({}, {
      title: 'Unforgettable cruises',
      subtitle: 'Get access to sailings onboard the world\'s most luxurious ships with unmatched service',
      imageId: 'nm8nh9vh6sys7ifvjnf',
    }),
    service: switchFunc<USPDefinition>({
      IN: {
        title: 'Premium concierge service',
        subtitle: 'Our team are available anytime, 9am to 7pm, 7 days a week.',
        imageId: '86zfuzec9prni5yzhzcd',
      },
    }, {
      title: '24/7 Premium concierge service',
      subtitle: 'Our team are available anytime, 24 hours, 7 days a week',
      imageId: '86zfuzec9prni5yzhzcd',
    }),
  },

}
